export default {
  'content-default': 'content-default',
  'content-page-collection-card': 'content-page-collection-card',
  primaryImage: 'primaryImage',
  secondaryImage: 'secondaryImage',
  contentWrapper: 'contentWrapper',
  linkButton: 'linkButton flex flex-col-reverse mt-20 text-black',
  title:
    'title sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-6 md:pt-16 sm:pt-16',
  subText:
    'subText headingWrapper sm:text-18 md:text-30  leading-30 font-BornreadyRegular',
  collectionCarouselParent: 'w-full flex flex-wrap',
  collectionCarouselCardWidth: 'w-full',
  collectionRelatedProdDiv: 'collection_data',
};
